<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Dvorane</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                        @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>

import Datatables from "@/components/datatable/Datatables";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
import axios from "axios";

export default {
    name: "Dvorane",
    components: {
        Datatables,
        SkupoviNavigation
    },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'dvorana',
            datatables: {},
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id,
            skup: null
        }
    },
    methods:{
        getSkup(){
            let vm = this
            axios.get( process.env.VUE_APP_API_URL + 'skup' + '/' + vm.skup_id )
                    .then( function ( response ) {
                        vm.skup = response.data
                        vm.setDatatable()
                    } )
                    .catch( function ( error ) {
                        if(error instanceof Error) {
                            console.log( 'Error: ' . error);
                        } else {
                            console.log( 'Unexpected response: ' . error);
                        }
                    } )
        },
        rowClick( row ){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/dvorane/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/dvorane/create' } )
        },

        setDatatable() {

            let vm = this;

            console.log( vm.skup );

            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'skup_dvorana_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.skup.skup_dvorane.id
                            },
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'column_visibility_group': {
                                id: 'dvorane',
                            }
                        },
                        {
                            'id': 'users',
                            'title': 'Korisnici',
                            'type' : function( row ){
                                let ret = ''
                                row.dvorana_users.forEach( function( item ){
                                    ret += item.user.username + '; '
                                })
                                return ret
                            },
                            searchable: false,
                            orderable: false,
                            'column_visibility_group': {
                                id: 'teme',
                            }
                        },
                    ],
                    column_visibility_groups:{
                        'dvorane' : 'Dvorane'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Dvorane',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/dvorane',
                    name: 'Dvorane'
                }
            ]
        }
    },
    mounted() {
        this.getSkup()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>